export const ORGANIZATIONS_API = '/api/v1/organizations';
